import lineRef from 'assets/json/line-ref'

export const drumSounds = [
  'clap',
  'hihat-closed',
  'hihat-open',
  'kick',
  'ride',
  'snare',
  'tom-high',
  'tom-low',
  'tom-mid',
]

export const noteDurations = [1, 2, 4, 8, 16, 32]
export const beatLengths    = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const playTypes    = Object.keys(lineRef)
export const harmonyTypes = ['Slow', 'Medium', 'Fast']
export const synths       = [
  'Synth',
  'AMSynth',
  'FMSynth',
  'MonoSynth',
]
export const instruments  = [
  'bass-electric',
  'basson',
  'cello',
  'clarinet',
  'contrabass',
  'flute',
  'french-horn',
  'guitar-acoustic',
  'guitar-electric',
  'guitar-nylon',
  'harmonium',
  'harp',
  'organ',
  'piano',
  'saxophone',
  'trombone',
  'trumpet',
  'tuba',
  'violin',
  'xylophone',
]
export const LEAD         = 'lead'
export const DRUMS        = 'drums'
export const colors       = [
  'yellow',
  'yellow darken-1',
  'yellow darken-2',
  'yellow lighten-1',
  'yellow lighten-2',
  'green',
  'green darken-1',
  'green darken-2',
  'green lighten-1',
  'green lighten-2',
]

// const drumMidi = {}
// Object.entries(drumMidiRef).forEach(([key, val]) => {
//   drumMidi[parseInt(key)] = val
// })
